export const environment = {
  production: false,
  ymunityApiUrl: "https://dev2-api.ymunity.com.br/api",
  recaptchaPublicKey: "6LeSMxkpAAAAAMy7sGycRdjr_fW1YTacfxPsTnM2",
  enableHotjarTracking: true,
  hotjarId: "5024637",
  hotjarVersion: "6",
  analyticsId: "G-JC3PC2LBGN",
};
